import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroller";
import { Table, Button, Drawer, Icon, message } from "antd";
import { API } from "aws-amplify";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Container } from "./styled";
import Loading from "components/loading";

class BulkOrderList extends React.Component {
  state = {
    data: [],
    loading: true,
    hasMore: true,
    selected: null,
    next: null,
  };

  componentWillMount() {
    this.fetch();
  }

  fetch = () => {
    this.setState({ loading: true });
    API.get("api", `orders`, {
      queryStringParameters: {
        platform: 'fbq',
        limit: 50,
        next: this.state.next,
      }
    }).then(resp => {
      this.setState({
        data: [...this.state.data, ...resp.results],
        next: resp.next,
        loading: false,
        hasMore: !!resp.next,
      }, () => {
        if (resp.next && resp.results.length < 50) {
          this.fetch();
        }
      });
    });
  };

  showDetails = row => {
    this.setState({
      selected: row
    });
  };

  onClose = () => {
    this.setState({
      selected: null
    });
  };


  handleInfiniteOnLoad = () => {
    const { loading } = this.state;
    if (!loading) this.fetch();
  };

  renderDetails = item => {
    return (
      <Drawer
        visible
        maskClosable
        title="Items"
        width={450}
        onClose={this.onClose}
        style={{
          overflow: "auto",
          // height: "calc(100% - 108px)", removed as it stops the drawer from reaching the bottom? mixed results.
          paddingBottom: "108px"
        }}
      >
        {item.lineItems.map(i => {
          return (
            <div style={{ marginBottom: 10 }}>
              <strong>
                {i.product.name} - {i.images.length} image(s)
              </strong>
              <div>
                {i.product.size} - {i.product.cat_name} - Qty: {i.quantity}
              </div>
            </div>
          );
        })}
      </Drawer>
    );
  };

  render() {
    const { data, loading, hasMore, selected } = this.state;
    const columns = [
      {
        title: "Order ID",
        dataIndex: "orderId",
        key: "orderId",
        render: val => `F-${val}`
      },
      {
        title: "Status",
        key: "status",
        dataIndex: "status",
        render: val => val.toUpperCase(),
      },
      {
        title: "Order Date",
        dataIndex: "createdAt",
        render: val => moment(val).format("MM-DD-YYYY")
      },

      {
        title: "Items",
        dataIndex: "lineItems",
        key: "lineItems",
        render: val => val.length
      },
      {
        title: "Shipping Method",
        dataIndex: "shipping",
        render: val => val.shippingmethod,
      },
      {
        title: "Ship to",
        dataIndex: "shippingAddress",
        render: val => val ? (
          <div>
            {val.name}
            <br />
            {val.line1}, {val.line2}
            <br />
            {val.city}, {val.state}, {val.zip}
          </div>
        ) : null
      },
        {
        title: "Job Reference",
        key: "orderReference",
        dataIndex: "orderReference",
        width: "170px",
      },
      {
        title: "Tracking #",
        render: (val, row) =>
          row.status === "shipped" && (
            <span>
              <a
                target="_blank"
                href={`https://www.packagetrackr.com/track/${
                  row.trackingNumber
                }`}
              >
                {row.trackingNumber}
              </a>{" "}
              <CopyToClipboard
                title="Copy to Clipboard"
                text={row.trackingNumber}
                onCopy={() => message.success("Tracking number copied.")}
              >
              <Button size="small">
                  <Icon type="copy" theme="twoTone" />
                </Button>
              </CopyToClipboard>
            </span>
          )
      },
       {
        title: "Shipped On",
        dataIndex: "shippingDate",
        render: (val, row) =>
          row.status === "shipped" && moment(val).format("MM-DD-YYYY")
      },
      {
        title: "Total",
        dataIndex: "grandTotal",
        render: val => `$${val}`
      },
      {
        render: (val, row) => (
          <Button onClick={() => this.showDetails(row)}>Details</Button>
        )
      }
    ];

    return (
      <Container>
        <Helmet title="FBQ Orders" />
        <div
          className="d-flex"
          style={{ alignItems: "center", justifyContent: "space-between", paddingBottom: "20px" }}
        >
          <h1>FBQ Orders</h1>
          <div>
            <Link to="/bulk-orders/csv-order">
              <Button size="large" type="secondary">
                Create from CSV
              </Button>
            </Link>
            {' '}
            <Link to="/bulk-orders/create">
              <Button size="large" type="primary">
                Create an Order
              </Button>
            </Link>
          </div>
        </div>
        <InfiniteScroll
          initialLoad={false}
          pageStart={0}
          loadMore={this.handleInfiniteOnLoad}
          hasMore={!loading && hasMore}
          useWindow={true}
        >
          <Table
            rowKey="id"
            dataSource={data}
            columns={columns}
            pagination={false}
            loading={loading && !data.length}
          />
          {loading && data.length && hasMore && <Loading size="small" /> || null}
        </InfiniteScroll>
        {selected ? this.renderDetails(selected) : null}
      </Container>
    );
  }
}

export default BulkOrderList;
